import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import Dialog from "../Dialog";
import Modal from "../Modal";
import { jsx as _jsx } from "react/jsx-runtime";
function ModalDialog(_ref) {
  var modalProps = _ref.modalProps,
    dialogProps = _ref.dialogProps;
  return /*#__PURE__*/_jsx(Modal, _extends({}, modalProps, {
    children: /*#__PURE__*/_jsx(Dialog, _extends({}, dialogProps))
  }));
}
export default ModalDialog;